import { Box, Container, Stack } from '@mui/material'
import React, { useLayoutEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { LoginPoster } from '../../components'
import Dashboard from '../../components/Layouts/dashboardLayout'
import { useMobile } from '../../hooks/useMoblie'
import { useAuth } from '../../providers'
import OTPVerificationForm from './components/OTPVerificationForm'

const OTPVerification = () => {
    const { isUserLoggedIn, phoneNumber } = useAuth()

    const navigate = useNavigate()
    const location = useLocation()

    useLayoutEffect(() => {
        if (!phoneNumber) {
            navigate('/login')
        }
    })
    const isMobile = useMobile()

    useLayoutEffect(() => {
        if (isUserLoggedIn) {
            navigate(location?.state?.from || '/bookings')
        }
    }, [isUserLoggedIn, navigate, location])

    return (
        <Dashboard showDashboard={false}>
            <Container>
                <Stack direction={isMobile ? 'column' : 'row'} alignItems="center" justifyContent="space-evenly">
                    <Box
                        sx={{
                            width: isMobile ? '100%' : '65%',
                        }}
                    >
                        <LoginPoster />
                    </Box>

                    <OTPVerificationForm />
                </Stack>
            </Container>
        </Dashboard>
    )
}

export default OTPVerification
